import React, { memo, useContext, useRef } from "react";
import { AppContext } from "./App";
import { useFrame } from "@react-three/fiber";
import { Color } from "three";
import { Sparkles, Stars } from "@react-three/drei";

const Landscape = memo(function Landscape() {
  const { worldSize, wallThickness, wallOpacityRef, highGraphics } =
    useContext(AppContext);
  const wallColorMin = 60;
  const wallMaterialRef1 = useRef<any>();
  const wallMaterialRef2 = useRef<any>();
  const wallMaterialRef3 = useRef<any>();
  const wallMaterialRef4 = useRef<any>();

  const opacityDeclineSpeed = 0.015;
  const wallColorRef = useRef(new Color());

  useFrame(() => {
    if (wallOpacityRef.current > 0) {
      wallOpacityRef.current -= opacityDeclineSpeed;

      const hexStr = Math.floor(
        wallOpacityRef.current * (120 - wallColorMin) + wallColorMin
      ).toString(16);

      wallMaterialRef1.current.color = wallColorRef.current;
      wallMaterialRef2.current.color = wallColorRef.current;
      wallMaterialRef3.current.color = wallColorRef.current;
      wallMaterialRef4.current.color = wallColorRef.current;

      wallColorRef.current.set("#" + hexStr + hexStr + hexStr);
    }
  });

  return (
    <>
      <mesh
        transparent
        position={[-worldSize.x / 2 - wallThickness / 2, 0, 0]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      >
        <planeGeometry
          args={[worldSize.x + wallThickness * 2, wallThickness]}
        />
        <meshBasicMaterial ref={wallMaterialRef1} />
      </mesh>
      <mesh
        position={[worldSize.x / 2 + wallThickness / 2, 0, 0]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      >
        <planeGeometry
          args={[worldSize.x + wallThickness * 2, wallThickness]}
        />
        <meshBasicMaterial ref={wallMaterialRef2} />
      </mesh>
      <mesh
        position={[0, 0, worldSize.z / 2 + wallThickness / 2]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      >
        <planeGeometry args={[wallThickness, worldSize.z]} />
        <meshBasicMaterial ref={wallMaterialRef3} />
      </mesh>
      <mesh
        position={[0, 0, -worldSize.z / 2 - wallThickness / 2]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
      >
        <planeGeometry args={[wallThickness, worldSize.z]} />
        <meshBasicMaterial ref={wallMaterialRef4} />
      </mesh>
      {highGraphics && (
        <>
          {/* @ts-ignore */}
          <Sparkles
            count={400}
            size={7}
            scale={[100, 30, 100]}
            color="#999999"
            speed={1.5}
            position={[0, 10, 0]}
            opacity={0.4}
          />
        </>
      )}
      {highGraphics && <Stars speed={0} count={200} depth={5} factor={2} />}
      {!highGraphics && <Stars speed={0} count={50} depth={5} factor={2} />}
    </>
  );
});
export default Landscape;
